import { DeepReadonly, IRecordedInterviewQuestion, QuestionTypeEnum } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultQuestions: DeepReadonly<IRecordedInterviewQuestion[]> = deepFreeze([
  {
    question: `Please hold your passport next to your face and clearly state your full name & date of birth`,
    description: `Get your passport photo page or ID photo ready and click "Start Now" to skip the countdown.`,
    duration: 30,
    thinkingTime: 30,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What was your inspiration to choose the UK as your study destination?`,
    description: `Why are you are excited about studying in the UK?`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What is the name of the course and what are the main modules that you will be studying?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What course / degree programme have you completed most recently? How are your previous studies related to your current course?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Excluding ranking, why did you choose this university?`,
    description: `Please state, at least, 3 reasons why you chose this university`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Please share some information about the two other universities you applied to or considered applying to.`,
    description: `What are the similarities and differences between these universities and us? Please speak freely about both the positive and the negative, your answer will not affect your application.`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What accommodation types did you consider and which one did you choose? `,
    description: `Please explain why you selected the option you did and why you DID NOT select an alternative option?`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What person or organisation is funding your tuition fees and what is the source of the funding?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Do you have any ambitions to work while studying the UK? After you have graduated, where do you plan to live and work?`,
    description: `If you have answered yes to the first question, please explain why.`,
    duration: 30,
    thinkingTime: 60,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Where do you see yourself in 5 years?`,
    description: `Provide a detailed summary of your future plans.`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  }
]);

export const trapQuestions: DeepReadonly<IRecordedInterviewQuestion[]> = deepFreeze([
  {
    question: `Which city in the UK are you most excited to visit?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `What three things do you think the UK is most famous for?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Can you name three famous tourist attractions in the UK?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Are there any food you are looking forward to trying in the UK? Why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Which teacher has most inspired you? Why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `List 3 example grounds for visa refusals`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Do you have any hobby you'd like to pursue whilst in the UK?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Do you know the name of Queen of the United Kingdom?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `What can you tell me about the British weather?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `What was your favourite subject to study at school and why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Tell me about your proudest achievement`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `If you could choose between being invisible and flying, which would you choose and why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Who is your favourite Youtuber?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  }
]);
